import {
  Activity,
  AlertTriangle,
  Asterisk02,
  BarChart10,
  BezierCurve02,
  Certificate02,
  Check,
  CheckCircle,
  CheckCircleBroken,
  CheckVerified03,
  ChevronDown,
  ChevronUp,
  Dataflow03,
  DotsVertical,
  Download01,
  Eye,
  EyeOff,
  File06,
  FileCheck01,
  FileDownload03,
  Grid01,
  InfoCircle,
  LayersThree01,
  LinkExternal01,
  List,
  Minus,
  NotificationMessage,
  Pencil01,
  Play,
  Plus,
  RefreshCcw02,
  Save01,
  Settings01,
  Settings04,
  Table,
  Trash01,
  UsersPlus,
  X,
  Zap,
  ZapFast,
} from '@untitledui/icons';
import {
  Ellipsis,
  GripVertical,
  PenLine,
  Redo2,
  Trash2,
  Undo2,
} from 'lucide-react';

export const IconMap = {
  activity: Activity,
  'alert-triangle': AlertTriangle,
  'asterisk-02': Asterisk02,
  'bar-chart-10': BarChart10,
  'bezier-curve-02': BezierCurve02,
  'certificate-02': Certificate02,
  check: Check,
  'check-circle': CheckCircle,
  'check-circle-broken': CheckCircleBroken,
  'check-verified-03': CheckVerified03,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'data-flow-03': Dataflow03,
  'dots-vertical': DotsVertical,
  'download-01': Download01,
  ellipsis: Ellipsis,
  eye: Eye,
  'eye-off': EyeOff,
  'file-06': File06,
  'file-check-01': FileCheck01,
  'file-download-03': FileDownload03,
  'grid-01': Grid01,
  'grip-vertical': GripVertical,
  'info-circle': InfoCircle,
  'layers-three-01': LayersThree01,
  'link-external-01': LinkExternal01,
  list: List,
  minus: Minus,
  'notification-message': NotificationMessage,
  'pen-line': PenLine,
  'pencil-01': Pencil01,
  play: Play,
  plus: Plus,
  'save-01': Save01,
  'redo-2': Redo2,
  'refresh-02': RefreshCcw02,
  'settings-01': Settings01,
  'settings-04': Settings04,
  table: Table,
  'trash-01': Trash01,
  'trash-2': Trash2,
  'undo-2': Undo2,
  'users-plus': UsersPlus,
  x: X,
  zap: Zap,
  'zap-fast': ZapFast,
};

export const commonIcons = Object.keys(IconMap).sort();

export type IconName = keyof typeof IconMap;
